import React from "react";
import logo from "assets/img/logo/logo-menu-white.png";
import bn from "utils/bemnames";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
//import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
  ListGroup,
  ListGroupItem,
  Col,
  Row,
  Collapse,
  NavbarToggler,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  MdInsertChart,
  MdPersonPin,
  MdExitToApp,
  MdFormatListBulleted,
  MdHome,
  MdArrowDropDown,
  MdLaunch,
} from "react-icons/lib/md";
import BadgePage from "../Perfil/Perfil";
import { dataUsuario } from "../../redux/actions/aLogin";
import { limpiarDisclaimer } from "../../redux/actions/aRamos";
import ImgAutoCotizacion from "assets/img/car.png";
import Avatar from "components/Avatar";
import { UserCard } from "components/Card";
import { dataUsuarioVacio } from "../../constants";
import { fetchGetPersonerias } from "../../redux/actions/aCotizacion";
import { urlAccesoBackoffice } from "../../constants/urls";

const bem = bn.create("header");

function Topics({ match }) {
  return (
    <div>
      <BadgePage />
    </div>
  );
}

class CabeceraHomePublica extends React.Component {
  constructor(props) {
    super(props);
    this.onClickSalir = this.onClickSalir.bind(this);
    this.props.fetchGetPersonerias();
    this.state = {
      isOpenNotificationPopover: false,
      isNotificationConfirmed: false,
      isOpenUserCardPopover: false,
    };

    //Barra de Navegacion
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
    };

    /*Menu hamburguesa */
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  onClickSalir = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.toggleUserCardPopover();
    localStorage.setItem("login", false);
    this.props.limpiarDisclaimer();
    this.props.setDataUsuario(dataUsuarioVacio);
    this.props.history.push({
      pathname: `/login`,
    });
  };

  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });
    if (!this.state.isNotificationConfirmed)
      this.setState({ isNotificationConfirmed: true });
  };

  toggleUserCardPopover = () =>
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover
        ? true
        : !this.state.isOpenUserCardPopover,
    });

  handleSidebarControlButton = (event) => {
    event.preventDefault();
    event.stopPropagation();
    document.querySelector(".cr-sidebar").classList.toggle("cr-sidebar--open");
  };
  closeMenu = () => this.setState({ isOpenUserCardPopover: false });
  toggle = () => this.setState({ isOpen: !this.state.isOpen });
  toggleNavbar = () => this.setState({ collapsed: !this.state.collapsed });

  componentDidMount() {    
    console.log("CabeceraHomePublica", this.props.datosUsuario.clienteFinal);
    if (
      this.props.datosUsuario &&
      this.props.datosUsuario.userIsLoggedIn === false
    ) {
      this.toggleUserCardPopover();
      localStorage.setItem("login", false);
      this.props.limpiarDisclaimer();
      this.props.setDataUsuario(dataUsuarioVacio);
    }
  }

  render() {
    const { data } = this.props.productosMenu;
    const { dataServicios } = this.props.serviciosMenu;
    console.log('DATA SERVICIOS ', dataServicios);
    console.log('DATA ', data);    
    let { carritoVisible, datosUsuario } = this.props;
    let urlPdf = "";
    console.log('PROPS', this.props)
    if (
      this.props.dataIncentivos &&  
      this.props.dataIncentivos.linkIncentivos &&
      this.props.dataIncentivos.linkIncentivos !== ''
    ) {        
      urlPdf = this.props.dataIncentivos.linkIncentivos;        
    }

    // if (!datosUsuario) {
    //   datosUsuario = {
    //     nombres: "",
    //     apellidos: "",
    //     correo: ""
    //   }

    // }

    // let iconoCotizacion=ImgAutoCotizacion;
    // let numeroItemsCarrito=this.props.cuentaCarrito === "" ? "0" : this.props.cuentaCarrito;
    // let totalCarrito=Object.keys(this.props.detalleCarrito.productosCarrito).length === 0 ? "$0" : ` $${this.props.detalleCarrito.productosCarrito.valorTotal.totalcarrito}`;

    let iconoCotizacion = this.props.datosTotalesCabeceraCotizadores.pathIcono
      ? this.props.datosTotalesCabeceraCotizadores.pathIcono
      : "";
    let numeroItemsCarrito = this.props.datosTotalesCabeceraCotizadores
      .totalItems
      ? this.props.datosTotalesCabeceraCotizadores.totalItems
      : "0";
    let totalCarrito = this.props.datosTotalesCabeceraCotizadores.totalPrima
      ? "$" + this.props.datosTotalesCabeceraCotizadores.totalPrima
      : "$0.00";

    //Renovaciones COndiciones
    let bloquearRenovaciones = true;
    if (
      (this.props.datosUsuario.usu_tipo_usuario === "canal-user" ||
        this.props.datosUsuario.usu_tipo_usuario === "asesor-user" ||
        this.props.datosUsuario.usu_tipo_usuario === "broker-user") &&
      this.props.datosUsuario.userIsLoggedIn === true
    ) {
      bloquearRenovaciones = false;
    }

    return (
      <div style={{ background: "#001871" }}>
        <Row className='cabecera-column-width'>
          <Col lg={5} md={5} sm={5} xs={5}>
            <Navbar
              expand='md'
              light
              className='menu-superior-pantallas-grandes'>
              <NavbarBrand href='/'></NavbarBrand>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className='ml-auto' navbar>
                  {/* <NavItem>
                    <div className={"menu-tag-a-disabled"}>Servicios</div>
                  </NavItem> */}
                  {/* Dropdown para Servicios */}
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      className='menu-link-a font-size-menu-home'>
                      {" "}
                      Servicios
                    </DropdownToggle>
                    <DropdownMenu>
                      {dataServicios &&
                        dataServicios.map(({ URL_interno, Nombre}) => (
                          <div key={Math.random()}>
                            <DropdownItem>
                              <Link
                                className="btn-color-main"
                                to={`/${URL_interno}`}>
                                {Nombre}
                              </Link>
                            </DropdownItem>
                          </div>
                        ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  {/* Dropdown para Productos */}
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      className='menu-link-a font-size-menu-home'>
                      {" "}
                      Productos
                    </DropdownToggle>
                    <DropdownMenu>
                      {data &&
                        data.map(({ urlDetalle, id, nombre, preSobre }) => (
                          <div key={Math.random()}>
                            <DropdownItem>
                              <Link
                               className="btn-color-main"
                                to={`${urlDetalle}?id=${id}&codigo=${
                                  preSobre !== undefined ? preSobre : ""
                                }`}>
                                {nombre}
                              </Link>
                            </DropdownItem>
                            {id < data.length && <DropdownItem divider />}
                          </div>
                        ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  {
                    <NavItem>
                      {bloquearRenovaciones && (
                        <div className={"menu-tag-a-disabled"}>
                          Renovaciones
                        </div>
                      )}
                      {!bloquearRenovaciones && (
                        <Link to={`/renovaciones`} className={"menu-tag-a"}>
                          Renovaciones
                        </Link>
                      )}
                    </NavItem>
                  }
                </Nav>
              </Collapse>
            </Navbar>
          </Col>
          <Col
            lg={2}
            md={2}
            sm={2}
            xs={2}
            style={{ textAlign: "center", marginTop: "0.5em" }}>
            <Link to={`/`}>
              <img
                src={logo}
                style={{ cursor: "pointer", width: "6em", height: "auto" }}
                alt='logo'
                className={"cabecera-publica-img"}
              />
            </Link>
          </Col>
          <Col lg={5} md={5} sm={5} xs={5} style={{ paddingLeft: "1px" }}>
            <table width='100%'>
              <tbody>
                <tr>
                  <td width='72%'>
                    <Navbar
                      expand='md'
                      light
                      className='menu-estilos-front menu-superior-pantallas-grandes'>
                      <NavbarBrand href='/'></NavbarBrand>
                      <NavbarToggler onClick={this.toggle} />
                      <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav navbar>
                          <NavItem>
                            <NavLink
                              href={urlPdf}
                              target='_blank'
                              rel='noopener noreferrer'
                              className={"menu-tag-a"}>
                              Incentivos
                            </NavLink>

                            {/* <NavLink href="/preguntas-frecuentes" className={"menu-link-a"}>PREGUNTAS FRECUENTES</NavLink> */}
                          </NavItem>
                          <NavItem className={"alinear-menus-md"}>
                            <Link
                              to={`/preguntas-frecuentes`}
                              className={"menu-tag-a"}>
                              Ayuda
                            </Link>
                            {/* <NavLink href="/preguntas-frecuentes" className={"menu-link-a"}>PREGUNTAS FRECUENTES</NavLink> */}
                          </NavItem>
                          <NavItem className={"alinear-menus-md"}>
                            {datosUsuario !== undefined &&
                              !datosUsuario.userIsLoggedIn &&
                              datosUsuario.clienteFinal !== undefined &&
                              !datosUsuario.clienteFinal && (
                                <Link
                                  to={`/login`}
                                  className={"link-iniciar-sesion"}>
                                  Iniciar Sesión
                                </Link>
                              )}
                          </NavItem>
                        </Nav>
                      </Collapse>
                    </Navbar>
                  </td>
                  <td width='28%'>
                    {console.log('datosUsuario_Popup', datosUsuario, Object.keys(datosUsuario).length > 0 && datosUsuario.userIsLoggedIn, this.props.userFromOkta)}
                    {Object.keys(datosUsuario).length > 0 &&
                      (datosUsuario.userIsLoggedIn || (this.props.userFromOkta !== undefined && this.props.userFromOkta !== null && this.props.userFromOkta !== '') ) && (
                        <Nav
                          navbar
                          className={bem.e(
                            "nav-right menu-avatar-min-pantallas"
                          )}>
                          {carritoVisible && (
                            <NavItem>
                              {" "}
                              <img
                                className='car-bar-style'
                                src={iconoCotizacion}
                              />{" "}
                            </NavItem>
                          )}
                          {carritoVisible && (
                            <NavItem>
                              <div className='posicion-navitem'>
                                <span className='dot'>
                                  {numeroItemsCarrito}
                                </span>
                              </div>
                            </NavItem>
                          )}
                          {carritoVisible && (
                            <NavItem>
                              <div className='posicion-navitem-value'>
                                {totalCarrito}
                              </div>
                            </NavItem>
                          )}
                          {/*datosUsuario.clienteFinal!==undefined && !datosUsuario.clienteFinal && (*/}
                          <NavItem>
                            <NavLink
                              id='Popover2'
                              className={"padding-botom-login"}>
                              <Avatar
                                onClick={this.toggleUserCardPopover}
                                className='can-click'
                              />
                              <div
                                className={"responsive-avatar"}
                                style={{ display: "none" }}>
                                <MdArrowDropDown />
                              </div>
                            </NavLink>

                            <Popover
                              placement='bottom-end'
                              isOpen={this.state.isOpenUserCardPopover}
                              toggle={this.toggleUserCardPopover}
                              target='Popover2'
                              className='p-0 border-0'
                              style={{ minWidth: 250 }}>
                              <PopoverBody className='p-0 border-light'>
                                <UserCard
                                  title={`${datosUsuario.nombres} ${datosUsuario.apellidos}`}
                                  subtitle={datosUsuario.correo}
                                  //text="Last updated 3 mins ago"
                                  className='border-light'>
                                  <ListGroup flush>
                                    {this.props.datosUsuario &&
                                      this.props.datosUsuario
                                        .usu_tipo_usuario !== "cliente" && (
                                        <Link
                                          to={`/principal`}
                                          onClick={this.closeMenu}>
                                          <ListGroupItem
                                            tag='button'
                                            action
                                            className='border-light set-cursor'>
                                            <MdHome /> Dashboard
                                          </ListGroupItem>
                                        </Link>
                                      )}

                                    {this.props.datosUsuario &&
                                      this.props.datosUsuario
                                        .usu_tipo_usuario !== "cliente" && (
                                        <Link
                                          to={`/listado-compras`}
                                          onClick={this.closeMenu}>
                                          <ListGroupItem
                                            tag='button'
                                            action
                                            className='border-light set-cursor'>
                                            <MdFormatListBulleted /> Listado de
                                            Ventas
                                          </ListGroupItem>
                                        </Link>
                                      )}

                                    {this.props.datosUsuario &&
                                      this.props.datosUsuario
                                        .usu_tipo_usuario !== "cliente" &&
                                      this.props.datosUsuario.cliCodigoCore && (
                                        //<Link to={`localhost/aig-backoffice/backend/web/index.php/site/ingresoportal?idUsuario=NWM1Yzk0OGYwMzliNGMzZDY3NDVjMDQ4`} onClick={this.closeMenu}>
                                        <a
                                          target='_blank'
                                          href={`${urlAccesoBackoffice}?idUsuario=${Buffer.from(
                                            this.props.datosUsuario
                                              .cliCodigoCore
                                          ).toString("base64")}`}
                                          onClick={this.closeMenu}>
                                          <ListGroupItem
                                            tag='button'
                                            action
                                            className='border-light set-cursor'>
                                            <MdLaunch /> Administrador Portal
                                          </ListGroupItem>
                                        </a>

                                        //</Link>
                                      )}

                                    {/*

                                  this.props.datosUsuario &&
                                this.props.datosUsuario
                                  .usu_tipo_usuario !== "cliente" && (
                                  <Link to={`/listado-compras`} onClick={this.closeMenu}>
                                    <ListGroupItem
                                      tag="button"
                                      action
                                      className="border-light set-cursor"
                                    >
                                      <MdFormatListBulleted/> Listado de Compras
                                    </ListGroupItem>
                                  </Link>
                                )

                                  */}

                                    {this.props.datosUsuario &&
                                      this.props.datosUsuario
                                        .usu_tipo_usuario !== "cliente" && (
                                        <Link
                                          to={`/listado-cotizaciones`}
                                          onClick={this.closeMenu}>
                                          <ListGroupItem
                                            tag='button'
                                            action
                                            className='border-light set-cursor'>
                                            <MdFormatListBulleted /> Listado de
                                            Cotizaciones
                                          </ListGroupItem>
                                        </Link>
                                      )}

                                    {this.props.datosUsuario &&
                                      this.props.datosUsuario
                                        .usu_tipo_usuario === "cliente" && (
                                        <React.Fragment>
                                          <Link
                                            to={`/mis-pagos`}
                                            onClick={this.closeMenu}>
                                            <ListGroupItem
                                              tag='button'
                                              action
                                              className='border-light set-cursor'>
                                              <MdFormatListBulleted /> Mis Pagos
                                            </ListGroupItem>
                                          </Link>

                                          <Link
                                            to={`/mis-compras`}
                                            onClick={this.closeMenu}>
                                            <ListGroupItem
                                              tag='button'
                                              action
                                              className='border-light set-cursor'>
                                              <MdFormatListBulleted /> Mis
                                              Compras
                                            </ListGroupItem>
                                          </Link>
                                        </React.Fragment>
                                      )}

                                    <Link
                                      to={`/miperfil`}
                                      onClick={this.closeMenu}>
                                      <ListGroupItem
                                        tag='button'
                                        action
                                        className='border-light set-cursor'>
                                        <MdPersonPin /> Perfil
                                      </ListGroupItem>
                                    </Link>

                                    <Link
                                      to={`/cambiar-contrasenia`}
                                      onClick={this.closeMenu}>
                                      <ListGroupItem
                                        tag='button'
                                        action
                                        className='border-light set-cursor'>
                                        <MdInsertChart /> Cambiar Contraseña
                                      </ListGroupItem>
                                    </Link>

                                    <ListGroupItem
                                      tag='button'
                                      onClick={this.onClickSalir}
                                      className='border-light set-cursor text-left'>
                                      <MdExitToApp /> Salir
                                    </ListGroupItem>
                                  </ListGroup>
                                </UserCard>
                              </PopoverBody>
                            </Popover>
                          </NavItem>

                          {/**  )} */}
                        </Nav>
                      )}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>

        <Row className='cabecera-column-width menu-superior-pantallas-pequenas'>
          <Col sm={12} xs={12}>
            <Navbar expand='md' light className='menu-estilos-front'>
              <NavbarBrand href='/'></NavbarBrand>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className='ml-auto' navbar>
                  {/* Dropdown para Servicios */}
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      className='menu-link-a font-size-menu-home'>
                      {" "}
                      Servicios
                    </DropdownToggle>
                    <DropdownMenu>
                      {dataServicios &&
                        dataServicios.map(({ URL_interno, Nombre}) => (
                          <div key={Math.random()}>
                            <DropdownItem>
                              <Link
                               className="btn-color-main"
                                to={`/${URL_interno}`}>
                                {Nombre}
                              </Link>
                            </DropdownItem>
                          </div>
                        ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  {/* Dropdown para Productos */}
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret className='menu-link-a'>
                      {" "}
                      Productos{" "}
                    </DropdownToggle>
                    <DropdownMenu>
                      {data &&
                        data.map(({ urlDetalle, id, nombre, preSobre }) => (
                          <div key={Math.random()}>
                            <DropdownItem>
                              <NavLink
                                href={`${urlDetalle}?id=${id}&codigo=${
                                  preSobre !== undefined ? preSobre : ""
                                }`}
                                className="btn-color-main">
                                {nombre}
                              </NavLink>
                            </DropdownItem>
                            {id < data.length && <DropdownItem divider />}
                          </div>
                        ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  {
                    <NavItem>
                      {bloquearRenovaciones && (
                        <div className={"menu-tag-a-disabled"}>
                          Renovaciones
                        </div>
                      )}
                      {!bloquearRenovaciones && (
                        <Link to={`/renovaciones`} className={"menu-tag-a"}>
                          Renovaciones
                        </Link>
                      )}
                    </NavItem>
                  }
                  <NavItem>
                    <NavLink
                      href={urlPdf}
                      target='_blank'
                      rel='noopener noreferrer'
                      className={"menu-tag-a"}>
                      Incentivos
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <Link to={`/preguntas-frecuentes`} className={"menu-tag-a"}>
                      Ayuda
                    </Link>
                  </NavItem>
                  <NavItem>
                    {Object.keys(datosUsuario).length === 0 && (
                      <Link to={`/login`} className={"link-iniciar-sesion"}>
                        Iniciar Sesión
                      </Link>
                    )}
                  </NavItem>
                </Nav>
              </Collapse>
            </Navbar>
          </Col>
        </Row>
      </div>
    );
  }
}

//export default withRouter(Header);
const mapStateToProps = (state) => ({
  datosUsuario: state.datosUsuarios.dataUsuario,
  cuentaCarrito: state.countCarrito,
  detalleCarrito: state.dataProductoCarrito,
  productosMenu: state.datosProductosMenu,
  serviciosMenu: state.rServicios,
  datosTotalesCabeceraCotizadores:
    state.datosTotalesCabeceraCotizadores.setTotalesCabeceraCotizadores,
  datosContenido: state.datosContenido,
  dataIncentivos: state.dataIncentivos,
});
const mapDispatchToProps = (dispatch) => ({
  setDataUsuario: (data) => dispatch(dataUsuario(data)),
  limpiarDisclaimer: () => dispatch(limpiarDisclaimer()),
  fetchGetPersonerias: () => dispatch(fetchGetPersonerias()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CabeceraHomePublica)
);
